// 根据说话人编号渲染不同的头像
export const getAvatar = (speakUser) => {
  const index = Number(speakUser.slice(3))

  switch (index) {
    case 1:
      return {
        color: '#A871E3',
        name: index
      }
    case 2:
      return {
        color: '#7B98FF',
        name: index
      }
    case 3:
      return {
        color: '#FF85C0',
        name: index
      }
    case 4:
      return {
        color: '#F9928A',
        name: index
      }
    case 5:
      return {
        color: '#4BCC6D',
        name: index
      }
    case 6:
      return {
        color: '#FFD971',
        name: index
      }
    default:
      return {
        color: '#248df5',
        name: index
      }
  }
}
